import './radio-choice.css';
import { h } from 'preact';

export default function RadioChoice({ id, name, text, value, matchCount, isChecked, onChangeHandler }) {
	function onChange() {
		if (typeof onChangeHandler === 'function') {
			onChangeHandler(name, value);
		}
	}

	return (
		<li class={'radio-filter-choice-container filter-choice-container' + (typeof matchCount === 'number' && matchCount === 0 ? ' has-no-results' : '')}>
			<input onChange={onChange} name={name} id={id} type="radio" checked={isChecked} />
			<label class="radio-filter-choice-label filter-choice-label" for={id}>{text}</label>
			{typeof matchCount === 'number' ?
				<span class="filter-choice-match-count">{matchCount}</span> : ''}
		</li>
	);
}
